module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAABUklEQVRYR+2YvUrFQBCFzyZpFUsVW9FH0F5BLH0EhYQsSS/3AcQn2CUpfAMtRbi311cQe7X0r9zNyoYERCx2ci/kIrNlcmbn8O0UwxEAkGXZdhzHlwAOAKz6byOcDwAza+15VVVPIs/zHSHEA4C1Ecz81fLNObcnpJTXAE4A3BljTuu6fhnDYJqmG0mSXAE4AnDjjb375zPGbI5lqgfRmXsG8OWNOf9DKSXGIPW7Z++HjYW+BhMLJdXrmBgToxKg6nnGmBiVAFU/eMbyPPfLJPlorWchRYON9YUhTX5qQreXeYxNqaa6teowpG6wsZDL59GwMSo9JsbEqASoep4xJkYlQNXzjP1LYksTQ0kp1wH4fK6Nofrg7hbAmVLqlYp/EfqyLLestRWA4za4K4pit2ma+2WKOqMo2m/Dui6HvQDgt8yVRRAYcMcngKlzbqK1fvwGRygWYrSz8Y4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/kline/jian.png
// module id = bkZa
// module chunks = 1